<template>
    <div>
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>
        
        <v-card class="mx-auto" width="1000" min-width="1000" color="#F4FEFB">
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col>
                            <span>{{ model.template_name }}</span>
                        </v-col>
                    </v-row>
                    <v-row align-content="center">
                        <v-col class="thumb_wrap" v-for="(dbFile, index) in dbFileList" :key="`1st-${index}`">
                            <div class="thumb" v-show="dbFile.id" @click="toPdfPreview(dbFile)">
                                <v-icon class="plus-icon" color="white">mdi-magnify</v-icon>
                                <pdf-thumb-component :pdfData="dbFile.pdfData" :scale="1" max-width="196px" :suffixes="index"></pdf-thumb-component>
                            </div>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span class="text-small" v-bind="attrs" v-on="on">{{ dbFile.pdfName }}</span>
                                </template>
                                <span>{{ dbFile.pdfName }}</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pb-0"><h3>■この契約の関係者</h3></v-col>
                    </v-row>
                    <v-row class="mt-0">
                        <v-col>
                            <workflow-component :items="destinationList" :user="user"></workflow-component>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="auto" class="pb-0"><h3>■送信先CSVインポート</h3></v-col>
                        <v-col align="right">
                            <input id="fileUpload" type="file" @change="inportCsv"  accept=".csv" hidden>
                            <v-btn @click="chooseFiles" color="orange" class="white--text">宛先のインポート(CSV)</v-btn>
                            <VueJsonToCsv :json-data="csvData" csv-title="一括送信CSVフォーマット" :labels="labels">
                                <v-btn @click="downloadCsvHeaderFile" color="orange" class="white--text">
                                    <v-icon>mdi-download</v-icon>
                                    CSVフォーマット
                                </v-btn>
                            </VueJsonToCsv>
                        </v-col>

                    </v-row>
                    <v-row>
                        <v-col class="py-0" style="max-height:550px; overflow-y: auto;">
                            <v-data-table
                                :headers="headers"
                                :items="signerItems"
                                hide-default-footer
                                :items-per-page="-1"
                            >
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                        </v-col>
                    </v-row>
                    <template v-if="signerItems.length > 0">
                        <!-- <v-row>
                            <v-col class="pb-0"><h3>■共有先</h3></v-col>
                        </v-row>
                        <v-row class="mt-0">
                            <v-col>
                                <div id="confirm-sticky-table" style="width: 100%;">
                                    <v-data-table :headers="sharingHeaders" :items="sharingItems" hide-default-footer fixed-header>
                                    <template v-slot:body="props">
                                        <tbody>
                                        <tr v-for="(item, index) in sharingItems" :key="index" >
                                            <td class="td_order"><span>{{ index + 1 }}</span></td>
                                            <td class="td_name">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">{{ item.share_destination_name }}</span>
                                                </template>
                                                <span>{{ item.share_destination_name }}</span>
                                            </v-tooltip>
                                            </td>
                                            <td class="td_email"> {{ item.share_destination_email_address }} </td>
                                            <td class="td_company"> {{ item.destination_company_name }} </td>
                                            <td class="td_actionBtn"><v-btn color="blue" class="white--text" @click="editItem(item)">編集</v-btn></td>
                                            <td class="td_actionBtn"><v-btn color="blue-grey" class="white--text" @click="confirmDialog(item)">削除</v-btn></td>
                                        </tr>
                                        </tbody>
                                    </template>
                                    <template v-slot:footer>
                                        <tr><td colspan=7 ><v-btn @click="addItem" color="orange" class="white--text">共有先を追加</v-btn></td></tr>
                                    </template>
                                    </v-data-table>
                                </div>
                            </v-col>
                        </v-row> -->
                        <v-row>
                            <v-col>
                                <label-component horizontal="left">■親展書類</label-component>
                                <v-radio-group v-model="stateIsConfidential" row >
                                    <v-radio label="親展書類として送信しない" :value="0"></v-radio>
                                    <v-radio label="親展書類として送信する" :value="1"></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row v-if="isPaid">
                            <v-col>
                                <label-component horizontal="left">■署名方式</label-component>
                                <v-radio-group v-model="signMethod" row >
                                    <v-radio
                                        v-for="(value, name, index) in signatureMethods"
                                        :key="index"
                                        :label="value"
                                        :value="name">
                                    </v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                            <badge-component tile content="任 意">
                                <label-component horizontal="left">■メッセージ</label-component>
                            </badge-component>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <validation-provider v-slot="{ errors }" name="stateEmailMessage" rules="max:10000" >
                                    <v-textarea auto-grow outlined clearable v-disabled-icon-focus rows="3" :placeholder="messagePlaceholder" :error-messages="errors" v-model="stateEmailMessage" background-color="white"></v-textarea>
                                </validation-provider>
                            </v-col>
                        </v-row>
                    </template>
                </v-container>
            </v-card-text>
        </v-card>
        <div class="text-center pt-2">
            <v-btn color="red" class="white--text" :disabled="!isValid"  @click="confirmSendDialog = true">送る</v-btn>
        </div>

        <!-- 共有先ダイアログ -->
        <sharing-dialog-component v-if="sharingDialog" :sharingDialog.sync="sharingDialog" :currentSharingList="sharingItems" :currentIndex="currentIndex" :currentItem="currentItem" @clickOk="changeEvent">
            <template v-slot:ok-btn>OK</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </sharing-dialog-component>
        <!-- 削除確認ダイアログ -->
        <simple-dialog-component v-if="confirmDeleteDialog" :dialog.sync="confirmDeleteDialog" :currentItem="currentItem" :currentIndex="currentIndex" @clickOk="deleteItem(currentItem)" okBtn="削除" cancelbtn="キャンセル">
            <div>{{ currentItem.share_destination_name }}を削除しますか？</div>
        </simple-dialog-component>
        <!-- 送信確認ダイアログ -->
        <simple-dialog-component v-if="confirmSendDialog" :dialog.sync="confirmSendDialog" @clickOk="confirm" okBtn="送信する" cancelbtn="キャンセル">
            <div>書類の内容に同意のうえ送信しますか？</div>
        </simple-dialog-component>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import VueJsonToCsv from "vue-json-to-csv";
    import { parse } from 'csv-parse/sync';
    import { signatureMethodMixin } from '../../mixins/signatureMethodMixin.js';

    export default {
        components:{
            draggable,           // ドラッグ＆ドロップ
        },
        mixins:[
            signatureMethodMixin,
        ],
        props: {
            user: Object,
            model: Object,
            sender: Object,
            destinationList: Array,         // 契約送付先リスト
            dbFileList: Array,
            inputs: Array,
            isPaid: Boolean,
        },
        data() {
            return {
                senderItem:[],
                confirmAuthorizerDeleteDialog: false,
                signerItems: [],
                signerDialog: false,
                confirmDeleteDialog: false,
                headers: [],
                inportCsvData:[],
                csvData: [],
                labels: {},
                sharingHeaders: [
                    { text: '', value: 'sn', sortable: false, width: '65' },
                    { text: '氏名', value: 'share_destination_name', sortable: false },
                    { text: 'メールアドレス', value: 'share_destination_email_address', sortable: false },
                    { text: '会社名', value: 'destination_company_name', sortable: false, width: '50'  },
                    { text: '', value: 'edit', sortable: false, width: '75' },
                    { text: '', value: 'delete', sortable: false, width: '75' },
                ],
                sharingItems: [],
                sharingDialog: false,
                confirmDeleteDialog: false,
                stateIsConfidential: Boolean,
                signMethod: 'sign_long',
                stateEmailMessage: '',
                messagePlaceholder: 'メールにメッセージを付けられます。(任意) \n ※受信者全員のメールに記載されます。', 
                confirmSendDialog: false,
                sending: false,
                message: {
                    success: false,
                    text: '',
                },
            };
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
            isValid: {
                get() {
                    if (this.signerItems.length > 0){
                        for(let i = 0; i < this.signerItems.length; i++) {
                            if (!(this.signerItems[i].メールアドレス.length > 0) || !(this.signerItems[i].氏名.length > 0)) {
                                return false;
                            }
                        }
                    } else {
                        return false;
                    }
                    return true;
                },
                set(value) {
                    
                }
            }
        },
        // 初期表示のデータ
        created : function() {
            this.senderItem = this.sender;
            var header = ['氏名','メールアドレス','会社名','アクセスコード'];
            header = [...header, ...this.inputs];
            this.headers = header.map(item => {
                return { text: item, value: item, sortable: false };
            });

            this.labels = {};
            header.map((header) => {
                this.labels[header] = { title: header };
            });

            this.signMethod = this.model.signature_method?? 'sign_long';
            this.stateIsConfidential = 0;
        },
        methods: {
            chooseFiles: function() {
                document.getElementById("fileUpload").click();
            },
            downloadCsvHeaderFile: function() {
                this.csvData = [];
                let record = {}
                this.headers.forEach((header) => {
                    record[header.text] = "";
                });
                this.csvData.push(record);
            },
            // CSVファイル読み込む
            inportCsv:function(e) {
                var self = this;
                let file = e.target.files[0] || e.dataTransfer.files[0];
                var header = ['氏名','メールアドレス','会社名','アクセスコード'];
                header = [...header, ...this.inputs];

                let reader = new FileReader();
                reader.readAsText (file, 'utf-8');
                reader.onload = () => {
                    try {                        
                        const records = parse(reader.result);
                        let arrHeader = records[0];
                        if(JSON.stringify(arrHeader) != JSON.stringify(header)){
                            self.message.text = "正しい宛先CSVファイルを選択してください"+JSON.stringify(arrHeader) + JSON.stringify(header);
                            return;
                        }
                        let csvResult = records.filter(item => item.some(item => item)).map(item => {
                            let _str = {};
                            item.forEach((v, i) => {
                                _str[arrHeader[i]] = v.trim();
                            });
                            return _str;
                        });
                        if (csvResult.length > 101){
                            self.message.text = "CSVファイルの行数が100行を超えています。";
                            return;
                        }
                        csvResult.shift()
                        this.inportCsvData = csvResult
                        // 画面表示追加
                        this.signerItems = this.inportCsvData;
                    } catch (error) {
                        self.message.text = "CSVファイル読み込みに失敗しました。"+reader.result;                            
                        return;
                    }
                };
                // リセット
                document.getElementById("fileUpload").value = "";
            },
            addItem: function() {
                this.currentIndex = null;
                this.currentItem = {
                    // id: '',
                    share_destination_name: '',
                    share_destination_email_address: '',
                    destination_company_name: '',
                };
                this.sharingDialog = true;
            },
            editItem: function(item) {
                this.currentIndex = this.sharingItems.indexOf(item);
                this.currentItem = item;
                this.sharingDialog = true;
            },
            changeEvent: function(value) {
                if (this.currentIndex === null) {
                    this.sharingItems.splice(this.sharingItems.length, 0, value);
                } else {
                    this.$set(this.sharingItems, this.currentIndex, value);
                }
                this.currentItem = value;
            },
            confirmDialog: function(item) {
                this.currentIndex = this.sharingItems.indexOf(item);
                this.currentItem = item;
                this.confirmDeleteDialog = true;
            },
            deleteItem: function(item) {
                const index = this.sharingItems.indexOf(item);
                this.sharingItems.splice(index, 1);
            },

            confirm: async function() {
                this.sending = true;
                try {
                    let result = await this.send();
                    if (result) {
                        window.location = "/documents/dashboard?send=true&count=1";
                    }
                }
                finally {
                    this.sending = false;
                }
            },
            // 送信
            send: async function() {
                let result = false;
                // upload server

                var response = await axios.post(
                    'confirm',
                    {
                        'signer_items': this.signerItems,
                        'sharingList': this.sharingItems,
                        'is_confidential': this.stateIsConfidential,
                        'signature_method': this.signMethod,
                        'email_message': this.stateEmailMessage,
                    }
                )
                .catch(function (response) {
                    result = false;
                });
                result = response.data.success;
                if (response.data.message) {
                    this.message.text = response.data.message;
                    this.message.success = false;
                    // エラー対象のPDFを表示する
                    this.currentPdfId = response.data.fileId;
                    this.fileTab = Object.keys(this.pdfs).indexOf(response.data.fileId);
                    this.$refs.document[this.fileTab].currentPage = response.data.pageNum;
                }
                return result;
            },
            // pdfプレビュー画面へ
            toPdfPreview: function(dbFile) {
                // 別タブで開く
                window.open("/documents/document-management/template/" + this.model.object_id + "/pdf-preview/" + dbFile.object_id, '_blank');
            },

        },
        components: {
            VueJsonToCsv,
        },
    };
</script>

<style scoped>
    .thumb_wrap {
        width:240px;
        max-width: 240px;
        /*height:328px;*/
        /*max-height:328px;*/
    }
    .thumb {
        cursor : pointer;
        font-size: 14px;
        margin-left: 20px;
        position: relative;
    }
    .thumb:hover .plus-icon{
        opacity: 1;
        transform: scale(2, 2);
    }
    .plus-icon {
        cursor : pointer;
        opacity: 0;
        position: absolute;
        z-index:99;
        background-color:rgba(0,0,0,0.4);
        border-radius: 50%;
        top: 120px;
        left: 90px;
    }

    /* table */
    ::v-deep th {
        padding: 5px 0!important;
        word-break: keep-all;
        white-space : nowrap;
    }
    ::v-deep td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
        padding: 5px 0!important;
    }
    .td_move {
        width: 35px;
        text-align: center;
    }
    .td_order {
        width: 69px;
        text-align: center;
    }
    .td_name {
        width: 200px;
    }
    .td_email {
        /*width: 250px;*/
        padding-right: 15px !important;
    }
    .td_company {
        
    } 
    .td_actionBtn {
        width: 75px;
        text-align: center;
    }
    ::v-deep .v-data-table__empty-wrapper {
        display: none;
    }
</style>